import React from "react"
import styled from "styled-components"
import Slide from "react-reveal/Slide"
import videoPoster from "../../assist/images/about/videoPoster.jpg"
const AboutVideo = ({ lang }) => {
  const words = {
    ar: {
      text1: `رسالة الخير`,
      text2: "في كل",
      text3: "...مكان وزمان",
    },
    tr: {
      text1: `Her yerde `,
      text2: "ve her zamanda",
      text3: "hayır mesajı...... ",
    },
    en: {
      text1: `Alresala for Good`,
      text2: "everytime",
      text3: "and anywhere...... ",
    },
  }
  const { text1, text2, text3 } = words[lang]
  return (
    <Wraper>
      <div className="container">
        <div className="contenet">
          <div className="text">
            <Slide right big delay={1500}>
              <p>{text1}</p>
            </Slide>
            <Slide left big delay={1700}>
              <p className="midleText">{text2}</p>
            </Slide>
            <Slide right big delay={1900}>
              <p className="lastText">{text3}</p>
            </Slide>
          </div>
          <div className="videoContainer">
            <video controls poster={videoPoster} className="video">
              <source
                src="https://res.cloudinary.com/alresala/video/upload/v1600185757/albrwmw_95e45322bc_prnwnz.mp4"
                type="video/mp4"
              />
              <track
                src="captions_en.vtt"
                kind="captions"
                srclang="ar"
                label="english_captions"
              ></track>
            </video>
          </div>
        </div>
      </div>
    </Wraper>
  )
}

export default AboutVideo

const Wraper = styled.div`
  .contenet {
    padding: 50px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    .videoContainer {
      width: 50%;
      .video {
        width: 100%;
      }
    }
    .text {
      text-align: center;
      font-size: 1.5rem;
      &:first-child {
        color: ${props => props.theme.lg};
      }
      .midleText {
        color: #636363;
      }
      .lastText {
        color: ${props => props.theme.dg};
        font-weight: bold;
      }
      p {
        margin-bottom: 10px;
      }
    }
  }
  @media (max-width: 700px) {
    .contenet {
      display: block;
      padding: 10px;
      .videoContainer {
        width: 100%;
        margin: 0 auto;
      }
    }
    .text {
      padding: 23px 0px;
    }
  }
  @media (max-width: 550px) {
    .videoContainer {
      width: 100% !important;
    }
  }
`
